import { Route } from 'react-router-dom';
import RouteWrapper from '@/utils/RouteWrapper';

import React from 'react';

const buildRoutes = (routes, isPrivate = true) =>
  routes.map(({ path, element }, idx) =>
    React.createElement(Route, {
      key: idx,
      path,
      element: React.createElement(RouteWrapper, {
        element: React.createElement(element),
        isPrivate,
      }),
    }),
  );

export default buildRoutes;
